import { CareAppListActionFactory } from '../actions/action-factory';
import { CAAction, ORG_CONTEXT_CHANGE } from '../actions/index';
import { DataListState, INITIAL_DATA_LIST_STATE } from './data-list.state';

export class ReducerStateFactory<T> {
  get initialState(): DataListState<T> {
    return {
      ...INITIAL_DATA_LIST_STATE,
      ...this._initialState
    };
  }
  constructor(
    public actionClass: CareAppListActionFactory<any>,
    public readonly _initialState: any = {}
  ) {}

  /**
   * The reducer function
   */
  public reducer(state = this.initialState, action: CAAction): DataListState<T> {
    const allResult = this.allReducer(state, action);
    if (allResult) {
      return allResult;
    }

    const entityResult = this.entityReducer(state, action);
    if (entityResult) {
      return entityResult;
    }

    switch (action.type) {
      case this.actionClass.RESPONSE_FAIL:
        const error = action.payload.code || action.payload;
        return { ...state, error };

      case this.actionClass.SELECT_BY_ID:
        return { ...state, selectedId: action.payload.id };
      default:
        return state;
    }
  }

  allReducer(state, action: any) {
    switch (action.type) {
      case this.actionClass.PAGE_CHANGE:
        return { ...state, page: action.payload };
      case this.actionClass.UPDATE_FILTER:
        return { ...state, filter: action.payload, page: { ...state.page } };
      case this.actionClass.RESET_PAGE:
        return { ...state, page: { ...INITIAL_DATA_LIST_STATE.page } };
      case this.actionClass.REQUEST_ALL:
        return { ...state, loadingAll: true };
      case this.actionClass.RESPONSE_SUCCESS_COUNT:
        return { ...state, page: { ...state.page, length: action.payload } };
      case this.actionClass.REQUEST_SEARCH:
        return { ...state, searching: true, searchResults: [] };
      case this.actionClass.RESPONSE_SUCCESS_SEARCH: {
        const searchResults = action.payload.map(org => org.id);
        const ids = Array.from(new Set(state.ids.concat(searchResults)));
        const entities = {
          ...state.entities,
          ...action.payload.reduce((acc: any, entity: any) => ({ ...acc, [entity.id]: entity }), {})
        };
        return { ...state, searching: false, ids, entities, searchResults };
      }
      case this.actionClass.RESPONSE_FAIL_SEARCH:
        return { ...state, searching: false };

      case this.actionClass.RESPONSE_SUCCESS_ALL: {
        const ids = action.payload.map(org => org.id);
        const entities = action.payload.reduce(
          (acc: any, entity: any) => ({ ...acc, [entity.id]: entity }),
          {}
        );
        return { ...state, loadingAll: false, ids: ids, entities: entities };
      }

      case this.actionClass.RESPONSE_FAIL_ALL: {
        return { ...state, loadingAll: false, error: action.payload };
      }

      case ORG_CONTEXT_CHANGE: {
        return {
          ...state,
          page: INITIAL_DATA_LIST_STATE.page,
          filter: INITIAL_DATA_LIST_STATE.filter
        };
      }
    }
  }

  entityReducer(state, action: any) {
    switch (action.type) {
      // Request
      case this.actionClass.REQUEST_CREATE: {
        return { ...state, creating: true };
      }
      case this.actionClass.REQUEST_SAVE:
      case this.actionClass.REQUEST_BY_ID:
        return {
          ...state,
          loadingEntities: { ...state.loadingEntities, [action.payload.id]: true }
        };

      // Response Success
      case this.actionClass.RESPONSE_SUCCESS_SAVE:
      case this.actionClass.RESPONSE_SUCCESS_CREATE:
      case this.actionClass.RESPONSE_SUCCESS_BY_ID: {
        const ids = Array.from(new Set([...state.ids, action.payload.id]));
        const entities = { ...state.entities, [action.payload.id]: action.payload };
        return {
          ...state,
          loadingEntities: { ...state.loadingEntities, [action.payload.id]: false },
          creating: false,
          ids: ids,
          entities: entities
        };
      }
      case this.actionClass.RESPONSE_FAIL_CREATE:
        return {
          ...state,
          creating: false
        };

      // Response Fail
      case this.actionClass.RESPONSE_FAIL_BY_ID:
      case this.actionClass.RESPONSE_FAIL_SAVE:
        return {
          ...state,
          loadingEntities: { ...state.loadingEntities, [action.payload.id]: false }
        };
    }
  }
}
